'use client';

import { useState, type SubmitEvent } from 'react';
import { authClient } from '@/lib/auth-client';
import { useRouter } from 'next/navigation';

export default function LoginPage()
{
	const [pending, setPending] = useState(false);
	const [error, setError] = useState('');

	const router = useRouter();

	async function handleSubmit(event: SubmitEvent<HTMLFormElement>)
	{
		event.preventDefault();

		const formData = new FormData(event.currentTarget);

		setPending(true);
		setError('');

		try
		{
			const result = await authClient.signIn.email({
				email: String(formData.get('email')),
				password: String(formData.get('password')),
			});

			if (result.error)
			{
				setError('Sing-in failed. Check your email and password.');
				return;
			}

			router.replace('/account');
			router.refresh();
		}
		catch
		{
			setError('Could not complete sign-in. Please try again.');
		}
		finally
		{
			setPending(false);
		}
	}

	return (
		<main className="mx-auto max-w-md space-y-6 p-8">
			<h1 className="text-2xl font-bold">Sing in to NP</h1>

			<form onSubmit={handleSubmit} className="space-y-4">
				<div>
					<label htmlFor="email">Email</label>
					<input
						id="email"
						name="email"
						type="email"
						autoComplete="username"
						className="block w-full rounded border p-2"
						required
					/>
				</div>

				<div>
					<label htmlFor="password">Password</label>
					<input
						id="password"
						name="password"
						type="password"
						autoComplete="current-password"
						className="block w-full rounded border p-2"
						required
					/>
				</div>

				{error && <p role="alert">{error}</p>}

				<button
					type="submit"
					disabled={pending}
					className="rounded border px-4 py-2 disabled:opacity-50"
				>
					{pending ? <>Signing in&hellip;</> : 'Sign in'}
				</button>
			</form>
		</main>
	);
}
